import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface GetClientConversationDashboardStatParam {
	client: string
}
export type GetClientConversationDashboardStatResponse = Array<{
	_id: string
	email: string
	firstName: string
	conversation: number
}>
const getClientConversationDashboardStat = async (
	params: GetClientConversationDashboardStatParam
): Promise<GetClientConversationDashboardStatResponse> => {
	try {
		const { data } = await axios.get('v1/admin/insight/management/conversation', {
			params,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getClientConversationDashboardStat
